<template>
  <input
    class="kwt-submit-button"
    type="submit"
    :value="label"
    :disabled="disabled"
    @click.prevent="onSubmit"
  />
</template>
<script>
export default {
  props: {
    onSubmit: {
      type: Function,
      required: true
    },
    label: {
      type: String,
      default: 'SUBMIT'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/_vars";
input {
  border: 2px solid $kwtBlack;
  // the important tag will be removed when we re-architect the styling
  border-radius: 5px !important;
  background-color: $kwtGreen;
  display: inline-block;
  color: white;
  padding: 10px 25px 5px;
  text-transform: uppercase;
  font-family: "hwtfutura-semibold";
  width: auto;
  font-size: 20px;
  margin: 0;
  cursor: pointer;
  letter-spacing: 1px;
  transition: 0.1s linear;

  &:hover {
    transform: scale(1.1);
  }

  &:focus {
    outline: none;
  }
}
</style>
